<template>
  <button type="submit" :class="`a-button-primary ${buttonSubmit.class}`">
    <span v-show="!buttonSubmit.sending">{{ buttonSubmit.action }}</span>
    <div class="a-button-loading-dots" v-show="buttonSubmit.sending">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonSubmitPrimary',

  props: {
    buttonSubmit: Object
  }
}
</script>
